const formatDistanceLocale = {
  lessThanXSeconds: {
    one: 'chini ya sekunde',
    other: 'chini ya masekunde {{count}}',
  },

  xSeconds: {
    one: 'sekunde 1',
    other: 'masekunde {{count}}',
  },

  halfAMinute: 'nusu dakika',

  lessThanXMinutes: {
    one: 'Chini ya dakika',
    other: 'chini ya madakika {{count}}',
  },

  xMinutes: {
    one: 'dakika 1',
    other: 'madakika {{count}}',
  },

  aboutXHours: {
    one: 'Karibia saa 1',
    other: 'karibia masaa {{count}}',
  },

  xHours: {
    one: 'saa 1',
    other: 'masaa {{count}}',
  },

  xDays: {
    one: 'siku 1',
    other: 'siku {{count}}',
  },

  aboutXMonths: {
    one: 'karibia mwezi 1',
    other: 'karibia miezi {{count}}',
  },

  xMonths: {
    one: 'mwezi 1',
    other: 'miezi {{count}}',
  },

  aboutXYears: {
    one: 'karibia mwaka 1',
    other: 'karibia mwaka {{count}}',
  },

  xYears: {
    one: 'mwaka 1',
    other: 'miaka {{count}}',
  },

  overXYears: {
    one: 'Zaidi ya mwaka 1',
    other: 'zaidi ya {{count}} miaka',
  },

  almostXYears: {
    one: 'karibu mwaka 1',
    other: 'karibu {{count}} miaka',
  },
};

export default function formatDistance(token, count, options) {
  options = options || {};

  let result;
  if (typeof formatDistanceLocale[token] === 'string') {
    result = formatDistanceLocale[token];
  } else if (count === 1) {
    result = formatDistanceLocale[token].one;
  } else {
    result = formatDistanceLocale[token].other.replace('{{count}}', count);
  }

  if (options.addSuffix) {
    if (options.comparison > 0) {
      return 'ndani ' + result;
    }

    return result + ' iliyopita';
  }

  return result;
}
